/* 
 * map iranian names from persian to finglish
 * by ali hanafi
 */

export const names = new Map([
    ["امیرعلی",     "amir ali"],
    ["امیر علی",    "amir ali"],
    ["محمد",        "mohammad"],
    ["علی",         "ali"],
    ["امیرحسین",    "amir hosein"],
    ["امیر حسین",   "amir hosein"],
    ["ابوالفضل",    "abolfazl"],
    ["حسین",        "hosein"],
    ["امیرعباس",    "amir abbas"],
    ["امیر عباس",   "amir abbas"],
    ["محمدطاها",    "mohammad taha"],
    ["محمد طاها",   "mohammad taha"],
    ["محمدحسین",    "mohammad hosein"],
    ["محمد حسین",   "mohammad hosein"],
    ["کیان",        "kian"],
    ["پدرام",       "pedram"],
    ["محمدرضا",     "mohammad reza"],
    ["محمد رضا",    "mohammad reza"],
    ["امیرمحمد",    "amir mohammad"],
    ["امیر محمد",   "amir mohammad"],
    ["مهدی",        "mahdi"],
    ["محمدمهدی",    "mohammad mahdi"],
    ["محمد مهدی",   "mohammad mahdi"],
    ["امیررضا",     "amir reza"],
    ["امیر رضا",    "amir reza"],
    ["ماهان",       "mahan"],
    ["علی‌اصغر",     "ali asghar"],
    ["علی اصغر",    "ali asghar"],
    ["علیرضا",      "ali reza"],
    ["علی‌رضا",      "ali reza"],
    ["علی رضا",     "ali reza"],
    ["محمدامین",    "mohammad amin"],
    ["محمد امین",   "mohammad amin"],
    ["رضا",         "reza"],
    ["یاسین",       "yasin"],
    ["آراد",        "arad"],
    ["محمدجواد",    "mohammad javad"],
    ["محمد جواد",   "mohammad javad"],
    ["سامیار",      "samyar"],
    ["پارسا",       "parsa"],
    ["طاها",        "taha"],
    ["آریا",        "aria"],
    ["امیرمهدی",    "amir mahdi"],
    ["امیر مهدی",   "amir mahdi"],
    ["ایلیا",       "ilia"],
    ["بنیامین",     "benyamin"],
    ["محمدیاسین",   "mohammad yasin"],
    ["محمد یاسین",  "mohammad yasin"],
    ["سبحان",       "sobhan"],
    ["محمدصدرا",    "mohammad sadra"],
    ["محمد صدرا",   "mohammad sadra"],
    ["آرتین",       "artin"],
    ["آرین",        "arian"],
    ["محمدپارسا",   "mohammad parsa"],
    ["محمد پارسا",  "mohammad parsa"],
    ["رادین",       "radin"],
    ["پرهام",       "parham"],
    ["آیهان",       "ayham"],
    ["آرسام",       "arsam"],
    ["مهدیار",      "mahdiar"],
    ["رایان",       "rayan"],
    ["آرمین",       "armin"],
    ["مهرسام",      "mehrsam"],
    ["مهرداد",      "mehrdad"],
    ["حسام",        "hesam"],
    ["کارن",        "karen"],
    ["سهیل",        "soheil"],
    ["متین",        "matin"],
    ["آروین",       "arvin"],
    ["آرون",        "aroon"],
    ["کسری",        "kasra"],
    ["کیانوش",      "kianoosh"],
    ["کیارش",       "kiarash"],
    ["مجید",        "majid"],
    ["آرش",         "arash"],
    ["شایان",       "shayan"],
    ["فربد",        "farbod"],
    ["شاهین",       "shahin"],
    ["مصطفی",       "mostafa"],
    ["ابراهیم",     "ebrahim"],
    ["اسماعیل",     "esmaeel"],
    ["جلیل",        "jalil"],
    ["مهیار",       "mahyar"],
    ["میثم",        "meysam"],
    ["فرشاد",       "farshad"],
    ["حسن",         "hasan"],
    ["محمود",       "mahmood"],
    ["فرهاد",       "farhad"],
    ["هاشم",        "hashem"],
    ["سجاد",        "sajad"],
    ["عرفان",       "erfan"],
    ["سعید",        "saeed"],
    ["نوروز",       "norooz"],
    ["الیاس",       "elyas"],
    ["فیروز",       "firooz"],
    ["صمد",         "samad"],
    ["ایوب",        "ayoob"],
    ["حاتم",        "hatam"],
    ["اسلام",        "eslam"],
    ["ابوذر",       "abozar"],
    ["بهنام",       "behnam"],
    ["میلاد",        "milad"],
    ["حمید",        "hamid"],
    ["حمیدرضا",     "hamid reza"],
    ["حمید رضا",    "hamid reza"],
    ["وحید",        "vahid"],
    ["ناصر",        "naser"],
    ["قادر",        "ghader"],
    ["عزیز",        "aziz"],
    ["امیر",        "amir"],
    ["سینا",        "sina"],
    ["نیما",        "nima"],
    ["عباس",        "abbas"],
    ["محسن",        "mohsen"],
    ["فردین",       "fardin"],
    ["فرامرز",      "faramarz"],
    ["بهروز",       "behrooz"],
    ["بهرام",       "bahram"],
    ["روزبه",       "roozbeh"],
    ["جعفر",        "jafar"],
    ["امید",        "omid"],
    ["مرتضی",       "morteza"],
    ["احمدرضا",     "ahmad reza"],
    ["احمد رضا",    "ahmad reza"],
    ["مجتبی",       "mojtaba"],
    ["امین",        "amin"],
    ["پویا",        "pouya"],
    ["کوروش",       "koorosh"],
    ["داریوش",      "dariush"],
    ["احسان",       "ehsan"],
    ["احمد",        "ahmad"],
    ["حامد",        "hamed"],
    ["محمدعلی",     "mohammad ali"],
    ["محمد علی",    "mohammad ali"],
    ["جواد",        "javad"],
    ["پیمان",       "peyman"],
    ["پویان",       "pooyan"],
    ["ارشان",       "arshan"],
    ["آرشان",       "arshan"],
    ["موسی",        "moosa"],
    ["عیسی",        "isa"],
    ["دانیال",      "danial"],
    ["داود",        "davood"],
    ["داوود",       "davood"],
    ["مهران",       "mehran"],
    ["مبین",        "mobin"],
    ["هادی",        "hadi"],
    ["پوریا",       "pooria"],
    ["یاسر",        "yaser"],
    ["یوسف",        "yousef"],
    ["یونس",        "younes"],
    ["آرمان",       "arman"],
    ["اشکان",       "ashkan"],
    ["مانی",        "mani"],
    ["عرشیا",       "arshia"],
    ["محمدمتین",    "mohammad matin"],
    ["محمد متین",   "mohammad matin"],
    ["علی‌اکبر",     "ali akbar"],
    ["علی اکبر",    "ali akbar"],
    ["امیرحافظ",    "amir hafez"],
    ["امیر حافظ",   "amir hafez"],
    ["بردیا",       "bardia"],
    ["فاطمه",       "fatemeh"],
    ["زهرا",        "zahra"],
    ["حلما",        "holma"],
    ["زینب",        "zeynab"],
    ["یسنا",        "yasna"],
    ["نازنین",      "nazanin"],
    ["نازنین‌زهرا",  "nazanin zahra"],
    ["نازنین زهرا", "nazanin zahra"],
    ["آوا",         "ava"],
    ["باران",       "baran"],
    ["ریحانه",      "reyhane"],
    ["فاطمه‌زهرا",   "fatemeh zahra"],
    ["فاطمه زهرا",  "fatemeh zahra"],
    ["رها",         "raha"],
    ["آیلین",       "aylin"],
    ["بهار",        "bahar"],
    ["بهاره",       "bahareh"],
    ["مرسانا",      "mersana"],
    ["رقیه",        "roghayeh"],
    ["النا",        "elena"],
    ["سارا",        "sara"],
    ["محیا",        "mahya"],
    ["مریم",        "maryam"],
    ["مینا",        "mina"],
    ["حسنا",        "hosna"],
    ["مهرسا",       "mehrsa"],
    ["ثنا",         "sana"],
    ["اسرا",        "asra"],
    ["هلیا",        "helia"],
    ["کیمیا",       "kimia"],
    ["یکتا",        "yekta"],
    ["کوثر",        "kosar"],
    ["آتنا",        "atena"],
    ["الینا",       "elina"],
    ["مائده",       "maede"],
    ["نرگس",        "narges"],
    ["سعیده",       "saeedeh"],
    ["معصومه",      "maesoomeh"],
    ["آسنا",        "asna"],
    ["اسنا",        "asna"],
    ["سدنا",        "sadena"],
    ["سارینا",      "sarina"],
    ["هانا",        "hana"],
    ["هنا",         "hana"],
    ["گندم",        "gandom"],
    ["بارانا",      "barana"],
    ["رشا",         "rosha"],
    ["کامیار",      "kamyar"],
    ["هستی",        "hasti"],
    ["کیانا",       "kiana"],
    ["مهسا",        "mahsa"],
    ["نیکا",        "nika"],
    ["آوینا",       "avina"],
    ["نفس",         "nafas"],
    ["هلما",        "helma"],
    ["آیناز",       "aynaz"],
    ["عسل",         "asal"],
    ["نورا",        "nura"],
    ["آنیسا",       "anisa"],
    ["ملیکا",       "melika"],
    ["دیانا",       "diana"],
    ["آیدا",        "ayda"],
    ["اشرف",        "ashraf"],
    ["شهلا",         "shahla"],
    ["افروز",       "afrooz"],
    ["سمیه",        "somayeh"],
    ["کبری",        "kobra"],
    ["طاهره",       "tahereh"],
    ["لیلا",         "leyla"],
    ["شبنم",        "shabnam"],
    ["ندا",         "neda"],
    ["اکرم",        "akram"],
    ["اقدس",        "aghdas"],
    ["نادیا",       "nadia"],
    ["مرضیه",       "marzieh"],
    ["صدیقه",       "sedigheh"],
    ["ستایش",       "setayesh"],
    ["سوگند",       "sogand"],
    ["المیرا",      "elmira"],
    ["نفیسه",       "nafiseh"],
    ["مهنا",        "mohanna"],
    ["نیایش",       "niayesh"],
    ["محدثه",       "mohaddeseh"],
    ["پریا",        "paria"],
    ["مهدیس",       "mahdis"],
    ["حنانه",       "hananeh"],
    ["فاطیما",      "fatima"],
    ["یاسمین",      "yasamin"],
    ["مبینا",       "mobina"],
    ["حدیث",        "hadis"],
    ["الناز",       "elnaz"],
    ["نگین",        "negin"],
    ["مهدیه",       "mahdieh"],
    ["فائزه",       "faezeh"],
    ["سحر",         "sahar"],
    ["الهه",        "elaheh"],
    ["عاطفه",       "atefeh"],
    ["مهتاب",       "mahtab"],
    ["فرشته",       "fereshteh"],
    ["شقایق",       "shaghayegh"],
    ["نیلوفر",      "nilofar"],
    ["الهام",       "elham"],
    ["نگار",        "negar"],
    ["راضیه",       "razieh"],
    ["صبا",         "saba"],
    ["حانیه",       "hanieh"],
    ["هانیه",       "hanieh"],
    ["زهره",        "zohreh"],
    ["گلی",         "goli"],
    ["گلشیفته",     "golshifteh"],
    ["سمیرا",       "samira"],
    ["آرزو",        "arezoo"],
    ["یگانه",       "yeganeh"],
    ["مهلا",         "mahla"],
    ["اسماء",       "asma"],
    ["حدیثه",       "hadiseh"],
    ["شیدا",        "sheyda"],
    ["بیتا",        "bita"],
    ["نسترن",       "nastaran"],
    ["هنگامه",      "hengameh"],
    ["سید",         "seyed"],
    ["سیده",        "seyedeh"],
    ["حاج",         "haj"],
    ["میر",         "mir"],
    ["پور",         "poor"],
    ["محمدی",       "mohammadi"],
    ["حسینی",       "hoseini"],
    ["احمدی",       "ahmadi"],
    ["رضایی",       "rezaei"],
    ["کریمی",       "karimi"],
    ["موسوی",       "mousavi"],
    ["جعفری",       "jafari"],
    ["صادقی",       "sadeghi"],
    ["حیدری",       "heydari"],
    ["مرادی",       "moradi"],
    ["ابراهیمی",    "ebrahimi"],
    ["رحیمی",       "rahimi"],
    ["هاشمی",       "hashemi"],
    ["قاسمی",       "ghasemi"],
    ["صالحی",       "salehi"],
    ["کاظمی",       "kazemi"],
    ["اکبری",       "akbari"],
    ["امیری",       "amiri"],
    ["عباسی",       "abbasi"],
    ["اسدی",        "asadi"],
    ["امینی",       "amini"],
    ["باقری",       "bagheri"],
    ["طاهری",       "taheri"],
    ["نوری",        "noori"],
    ["علیزاده",     "alizadeh"],
    ["علی‌زاده",     "alizadeh"],
    ["علی زاده",    "alizadeh"],
    ["محمودی",      "mahmoodi"],
    ["شریفی",       "sharifi"],
    ["سلطانی",      "soltani"],
    ["نجفی",        "najafi"],
    ["زارع",        "zare"],
    ["یوسفی",       "yousefi"],
    ["زمانی",       "zamani"],
    ["نظری",        "nazari"],
    ["ملکی",        "maleki"],
    ["قربانی",      "ghorbani"],
    ["سلیمانی",     "soleymani"],
    ["رحمانی",      "rahmani"],
    ["غلامی",        "gholami"],
    ["عزیزی",       "azizi"],
    ["میرزایی",     "mirzaei"],
    ["حسنی",        "hasani"],
    ["خسروی",       "khosravi"],
    ["اسماعیلی",    "esmaeeli"],
    ["مقدم",        "moghadam"],
    ["عابدی",       "abedi"],
    ["بهرامی",      "bahrami"],
    ["کرمی",        "karami"],
    ["رستمی",       "rostami"],
    ["نصیری",       "nasiri"],
    ["توکلی",       "tavakoli"],
    ["غفاری",       "ghaffari"],
    ["خلیلی",       "khalili"],
    ["جلالی",        "jalali"],
    ["فتحی",        "fathi"],
    ["سلیمی",       "salimi"],
    ["انصاری",      "ansari"],
    ["فراهانی",     "farahani"],
    ["نوروزی",      "noroozi"],
    ["حبیبی",       "habibi"],
    ["عظیمی",       "azimi"],
    ["شفیعی",       "shafiee"],
    ["زارعی",       "zarei"],
    ["افشار",       "afshar"],
    ["رمضانی",      "ramezani"],
    ["نادری",       "naderi"],
    ["مهدوی",       "mahdavi"],
    ["دهقان",       "dehghan"],
    ["دهقانی",      "dehghani"],
    ["رجبی",        "rajabi"],
    ["شمس",         "shams"],
    ["بیات",        "bayat"],
    ["یزدانی",      "yazdani"],
    ["راد",         "rad"],
    ["امامی",       "emami"],
    ["محسنی",       "mohseni"],
    ["اسلامی",       "eslami"],
    ["علوی",        "alavi"],
    ["عسگری",       "asgari"],
    ["کیانی",       "kiani"],
    ["رنجبر",       "ranjbar"],
    ["فلاح",         "fallah"],
    ["عبدالهی",     "abdollahi"],
    ["قنبری",       "ghanbari"],
    ["رشیدی",       "rashidi"],
    ["لطفی",        "lotfi"],
    ["کمالی",       "kamali"],
    ["عبدی",        "abdi"],
    ["جمشیدی",      "jamshidi"],
    ["رضوی",        "razavi"],
    ["تهرانی",      "tehrani"],
    ["جوادی",       "javadi"],
    ["بابایی",      "babaei"],
    ["علیپور",      "alipour"],
    ["طالبی",       "talebi"],
    ["ترابی",       "torabi"],
    ["اسکندری",     "eskandari"],
    ["مختاری",      "mokhtari"],
    ["منصوری",      "mansoori"],
    ["منصور",       "mansoor"],
    ["حمیدی",       "hamidi"],
    ["ناصری",       "naseri"],
    ["شهبازی",      "shahbazi"],
    ["نعمتی",       "nemati"],
    ["شعبانی",      "shabani"],
    ["ایرانی",      "irani"],
    ["جمالی",       "jamali"],
    ["سعیدی",       "saeedi"],
    ["عسکری",       "askari"],
    ["حاتمی",       "hatami"],
    ["صمدی",        "samadi"],
    ["فرجی",        "faraji"],
    ["کشاورز",      "keshavarz"],
    ["زاهدی",       "zahedi"],
    ["قادری",       "ghaderi"],
    ["فرهادی",      "farhadi"],
    ["شیرازی",      "shirazi"],
    ["خانی",        "khani"],
    ["اصغری",       "asghari"],
    ["صابری",       "saberi"],
    ["مومنی",       "momeni"],
    ["پناهی",       "panahi"],
    ["آزاد",        "azad"],
    ["ایزدی",       "izadi"],
    ["مرتضوی",      "mortazavi"],
    ["حقیقی",       "haghighi"],
    ["تقوی",        "taghavi"],
    ["رحمتی",       "rahmati"],
    ["گودرزی",      "goodarzi"],
    ["آزادی",       "azadi"],
    ["جلیلی",       "jalili"],
    ["بختیاری",     "bakhtiari"],
    ["عرب",         "arab"],
    ["حسین زاده",   "hoseinzadeh"],
    ["حسین‌زاده",    "hoseinzadeh"],
    ["عبادی",       "ebadi"],
    ["رسولی",       "rasouli"],
    ["مهرابی",      "mehrabi"],
    ["سالاری",       "salari"],
    ["شکری",        "shokri"],
    ["اشرفی",       "ashrafi"],
    ["بخشی",        "bakhshi"],
    ["مجیدی",       "majidi"],
    ["ایمانی",      "imani"],
    ["رضوانی",      "rezvani"],
    ["شاکری",       "shakeri"],
    ["شجاعی",       "shojaei"],
    ["کلانتری",      "kalantari"],
    ["براتی",       "barati"],
    ["امیدی",       "omidi"],
    ["طهماسبی",     "tahmasebi"],
    ["رفیعی",       "rafiee"],
    ["اخوان",       "akhavan"],
    ["افشاری",      "afshari"],
    ["فاطمی",       "fatemi"],
    ["فاظلی",       "fazeli"],
    ["تقی زاده",    "taghizadeh"],
    ["تقی‌زاده",     "taghizadeh"],
    ["ملک",         "malek"],
    ["مدنی",        "madani"],
    ["وکیلی",       "vakili"],
    ["محمدزاده",    "mohammadzadeh"],
    ["محمد زاده",   "mohammadzadeh"],
    ["آقایی",       "aghaei"],
    ["حاجی",        "haji"],
    ["کشانی",       "kashani"],
    ["طباطبایی",    "tabatabaei"],
    ["داوودی",      "davoodi"],
    ["زندی",        "zandi"],
    ["شریف",        "sharif"],
    ["سعادت",       "saadat"],
    ["معصومی",      "maesoomi"],
    ["بهمنی",       "bahmani"],
    ["افتخاری",     "eftekhari"],
    ["آذری",        "azari"],
    ["بهشتی",       "beheshti"],
    ["خادمی",       "khademi"],
    ["میری",        "miri"],
    ["احمدیان",     "ahmadian"],
    ["ذولفقاری",    "zolfaghari"],
    ["فتاحی",       "fattahi"],
    ["حنفی",        "hanafi"],
    ["جوهری",       "johari"],
    ["نورجعفری",    "noorjafari"],
    ["نظامی",       "nezami"],
 ]);

 export const getFinglish = name => {
    name = String(name);

    if (names.get(name) != undefined) {
        return names.get(name);
    }

    let getSub = '';

    if (name.substring(0, 4) == "سید ") {
        getSub = names.get(name.substring(4));

        if (getSub != undefined) {
            return 'seyed ' + getSub;
        }
    }

    if (name.substring(0, 4) == "سیده") {
        getSub = names.get(name.substring(4));

        if (getSub != undefined) {
            return 'seyedeh ' + getSub;
        }
    }

    if (name.substring(0, 3) == "سید") {
        getSub = names.get(name.substring(3));

        if (getSub != undefined) {
            return 'seyed ' + getSub;
        }
    }

    if (name.substring(0, 4) == "حاج ") {
        getSub = names.get(name.substring(4));

        if (getSub != undefined) {
            return 'haj ' + getSub;
        }
    }

    if (name.substring(0, 3) == "حاج") {
        getSub = names.get(name.substring(3));

        if (getSub != undefined) {
            return 'haj ' + getSub;
        }
    }

    if (name.substring(0, 4) == "میر ") {
        getSub = names.get(name.substring(4));

        if (getSub != undefined) {
            return 'mir ' + getSub;
        }
    }

    if (name.substring(0, 3) == "میر") {
        getSub = names.get(name.substring(3));

        if (getSub != undefined) {
            return 'mir' + getSub;
        }
    }

    if (name.substring(0, 4) == "پور ") {
        getSub = names.get(name.substring(4));

        if (getSub != undefined) {
            return 'poor ' + getSub;
        }
    }

    if (name.substring(0, 3) == "پور") {
        getSub = names.get(name.substring(3));

        if (getSub != undefined) {
            return 'poor' + getSub;
        }
    }

    return false;
 };
